import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import FormProfileKYCSuccessPopup from './popup';

const FormProfileKYCSuccessModal = ({ isShow, actionClose }) => {
  const { closePortalModalName } = usePortalModal();

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <FormProfileKYCSuccessPopup
      isOpen={isShow}
      onClose={handleOnClose}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1068}
      zIndexModal={1069}
    />
  );
};

export default FormProfileKYCSuccessModal;
